<template>
  <div>
    <div
      class="flex justify-between items-center bg-[#fdf4ff] p-4 rounded-lg cursor-pointer"
      @click="showQRCode"
    >
      <div class="flex flex-col">
        <span class="text-normal-emphasis">{{ trackerRequiredMessage }}</span>
        <span class="text-normal-emphasis font-bold">Scan now!</span>
      </div>
      <div class="">
        <i class="fas fa-chevron-right text-sm"></i>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useEventParticipantStore } from "@/store/EventParticipant";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const props = defineProps({
  userQRCodeRef: {
    type: Object
  },
  trackerRequiredForThisStop: {
    type: Object
  },
  nextStop: {
    type: Object
  }
});

const trackerRequiredMessage = computed(() => {
  if (props.trackerRequiredForThisStop?.name) {
    return `${props.trackerRequiredForThisStop.name} check in is required at ${props.nextStop?.name ?? "stop " +props.trackerRequiredForThisStop.requiredStopNumber} before your next card can be dealt.`;
  }
  return "";
});

const showQRCode = () => {
  props.userQRCodeRef?.toggleShowModal();
};
</script>
